
export const serverAppConfig = {
  "storeId": "67bc6ae888ee93f4558183d9",
  "categories": [
    {
      "id": "67bc882cb30a5d17ef7b44df",
      "name": "Produkter",
      "slug": "produkter",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/underbank16.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/1313.png",
      "order": 1,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": [
        {
          "id": "67bc882cb30a5d17ef7b44e0",
          "name": "Under bord",
          "slug": "produkter-under-bord",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/underbank16.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/1212.png",
          "order": 1,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": [
            {
              "id": "67bc882cb30a5d17ef7b4504",
              "name": "Vinkøler 30cm",
              "slug": "produkter-under-bord-vinkler-30cm",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 2.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/banner30cm.png",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "67bc882cb30a5d17ef7b4505",
              "name": "Vinkøler 40cm",
              "slug": "produkter-under-bord-vinkler-40cm",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 3.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/banner40cm.png",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "67bc882cb30a5d17ef7b4506",
              "name": "Vinkøler 60cm",
              "slug": "produkter-under-bord-vinkler-60cm",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/44.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/1313.png",
              "order": 3,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "67bc882cb30a5d17ef7b44e1",
          "name": "Fritstående vinkøler",
          "slug": "produkter-fritstaende-vinkler",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Detalj Vigneron 3 (11).jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Detalj Vigneron 3 (11).jpg",
          "order": 5,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "67bc882cb30a5d17ef7b44e2",
          "name": "Indbygget i skabe",
          "slug": "produkter-indbygget-i-skabe",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/5arbuilt.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/built14.png",
          "order": 2,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "67bc882cb30a5d17ef7b44e3",
          "name": "Integreret vinkøler",
          "slug": "produkter-integreret-vinkler",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bannerjanapidi.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/mobilen5ar.png",
          "order": 3,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "67bc882cb30a5d17ef7b44e4",
          "name": "Vinopbevaringsskabe",
          "slug": "produkter-vinopbevaringsskabe",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/storage5ar.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/storage5.png",
          "order": 4,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "67bc882cb30a5d17ef7b44e5",
          "name": "Tilbehør",
          "slug": "produkter-tilbehr",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/tillbehor.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Detalj Vigneron lable view6 (5).jpg",
          "order": 6,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": [
            {
              "id": "67bc882cb30a5d17ef7b4509",
              "name": "Hylder",
              "slug": "produkter-tilbehr-hylder",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/tillbehor.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/vigneronblogg50.png",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "67bc882cb30a5d17ef7b450a",
              "name": "Vintilbehør",
              "slug": "produkter-tilbehr-vintilbehr",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Vigneron professionale 2.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/vigneronblogg50.png",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "67f524d64f36c97c9e08a7e7",
              "name": "Rammeliste",
              "slug": "produkter-tilbehr-rammeliste",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKI45.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKI45.jpg",
              "order": 3,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "67bc882cb30a5d17ef7b4501",
          "name": "Richard Juhlin by Vigneron",
          "slug": "produkter-richard-juhlin-by-vigneron",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/juhlinxp.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/wjuhlindk.png",
          "order": 7,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        }
      ]
    },
    {
      "id": "67bc882cb30a5d17ef7b44e8",
      "name": "Vores ambassadører",
      "slug": "vores-ambassadrer",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bannerpartners.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Photoshoot-37.jpg",
      "order": 3,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": null
    },
    {
      "id": "67bc882cb30a5d17ef7b44ed",
      "name": "Inspiration",
      "slug": "inspiration",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/preentationsvart.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Gen-2--006.jpg",
      "order": 4,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": [
        {
          "id": "67bc882cb30a5d17ef7b44ee",
          "name": "Artikler",
          "slug": "inspiration-artikler",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Vigneron - vinlagring.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x1440 - 8.png",
          "order": 3,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "67bc882cb30a5d17ef7b44f0",
          "name": "Miljøbilleder",
          "slug": "inspiration-miljbilleder",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": null,
          "thumbnailUrl": null,
          "order": 2,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "67bc882cb30a5d17ef7b44f1",
          "name": "Stylingtips",
          "slug": "inspiration-stylingtips",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Gen-2--087.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Gen-2--087.jpg",
          "order": 4,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "67bc882cb30a5d17ef7b44f2",
          "name": "Samarbejder",
          "slug": "inspiration-samarbejder",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Banner.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/DSC02813.jpeg",
          "order": 5,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "67bc882cb30a5d17ef7b4500",
          "name": "Vinvæg",
          "slug": "inspiration-vinvg",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/kontaktsoss1.jpeg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/storage5.png",
          "order": 1,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        }
      ]
    },
    {
      "id": "67bc882cb30a5d17ef7b4502",
      "name": "Hotel & Restaurant",
      "slug": "hotel-restaurant",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/hoyellbanner.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/poggen-pohl-vigneron-27.jpg",
      "order": 2,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": null
    },
    {
      "id": "68b547a8779a353a3152095e",
      "name": "Udsalg",
      "slug": "udsalg",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 3.jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x1440 - 8.png",
      "order": 5,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": null
    }
  ],
  "storeType": "B2C",
  "storeDeliveries": [
    {
      "id": "681c7fffebbcb0618a30f003",
      "name": "Delivery 1",
      "label": "5-8 dage",
      "buyable": true
    },
    {
      "id": "6830801a1768d2605faf7072",
      "name": "Delivery 2",
      "label": "Ikke på lager",
      "buyable": true
    },
    {
      "id": "683080521768d2605faf7073",
      "name": "Delivery 3",
      "label": "1 - 2 uger",
      "buyable": true
    },
    {
      "id": "683080611768d2605faf7074",
      "name": "Delivery 4",
      "label": "3 - 4 uger",
      "buyable": true
    },
    {
      "id": "683080721768d2605faf7075",
      "name": "Delivery 5",
      "label": "1 - 2 måned",
      "buyable": true
    },
    {
      "id": "6830808f1768d2605faf7076",
      "name": "Delivery 6",
      "label": "3 + måned",
      "buyable": true
    }
  ],
  "language": "da",
  "currency": "DKK",
  "labels": {
    "assistantChatWith": "Chat med",
    "assistantChatWithFallback": "Kunde",
    "assistantShrink": "Skjul",
    "assistantExpand": "Udvid",
    "assistantMinimize": "Minimer",
    "assistantReply": "Svar",
    "assistantStatusSent": "Sendt",
    "assistantErrorServiceUnavailable": "Tjeneste utilgængelig",
    "assistantErrorUndelivered": "Ikke leveret",
    "assistantConversationStatusRecording": "Lytter...",
    "assistantConversationStatusProcessing": "Behandler...",
    "assistantConversationStatusProcessingResponse": "Forbereder svar...",
    "assistantConversationStatusProcessingResponding": "Svarer...",
    "assistantConversationStatusError": "Noget gik galt",
    "changePwdFormMsg": "Mindst 6 tegn, herunder et stort bogstav, et lille bogstav og et tal.",
    "changePwdFormOldPwd": "Gammel kodeord",
    "changePwdFormOldPwdRequired": "Gammelt kodeord er påkrævet.",
    "changePwdFormNewPwd": "Nyt kodeord",
    "changePwdFormNewPwdInvalid": "Kodeordet skal være mindst 6 tegn og indeholde et stort bogstav, et lille bogstav og et tal.",
    "changePwdFormRepeatPwd": "Gentag kodeord",
    "changePwdFormRepeatPwdMismatch": "Kodeordene matcher ikke.",
    "changePwdFormBtnLabel": "Gem",
    "changePwdFormBtnLoading": "Gemmer…",
    "loginFormBtnLoading": "Logger ind…",
    "loginFormEmailInvalid": "Indtast en gyldig e-mailadresse.",
    "loginFormPwdRequired": "Adgangskode er påkrævet.",
    "loginPageSubtitle": "Log ind for at se dine ordrer og administrere din profil.",
    "loginPageNewHere": "Ny her?",
    "signupFormBtnLoading": "Registrerer…",
    "signupFormEmailInvalid": "Indtast en gyldig e-mailadresse.",
    "signupFormFirstNameRequired": "Fornavn er påkrævet.",
    "signupFormLastNameRequired": "Efternavn er påkrævet.",
    "signupPageSubtitle": "Tilmeld dig for at følge ordrer og administrere dine oplysninger.",
    "signupAlreadyHaveAccount": "Har du allerede en konto?",
    "magicLinkFormBtnLoading": "Sender…",
    "magicLinkFormEmailInvalid": "Indtast en gyldig e-mailadresse.",
    "newPasswordPageSubtitle": "Indtast din e-mailadresse, så sender vi dig et link til at nulstille adgangskoden.",
    "newPasswordPageSuccess": "Hvis e-mailen findes hos os, er der sendt et link til nulstilling.",
    "loginForgottenPwd": "Glemt kodeord?",
    "loginForgottenPwdDesc": "En konto oprettes automatisk for dig, når du afgiver din første ordre, og instruktioner sendes med din ordrebekræftelse.",
    "toLogin": "Tilbage til login",
    "requestPwd": "Anmod om nyt kodeord",
    "accountRegistration": "For at kunne følge denne og andre ordrer nemmere kan du oprette en kodeord til kontoen.",
    "contactUsFormName": "Navn",
    "contactUsFormPhone": "Telefon",
    "contactUsFormEmail": "Email",
    "contactUsFormOrderDate": "Bestillingsdato",
    "contactUsFormProduct": "Produkt",
    "contactUsFormOrderNumber": "Ordrenummer",
    "contactUsFormDescription": "Beskrivelse",
    "contactUsFormLocation": "Beliggenhed",
    "contactUsFormBtnLabel": "Send",
    "contactUsFormAttachFiles": "Vedhæft filer",
    "contactConfirmationMessage": "Tak, fordi du indsendte din anmodning! Vi kontakter dig hurtigst muligt.",
    "discountFormName": "Ønsker du at tilføje en rabatkode?",
    "discountFormBtnLabel": "Tilføj rabat",
    "discountFormCodePlaceholder": "Rabatkode",
    "discountFormErrorNotFound": "Ugyldig rabatkode",
    "loginPageTitle": "Log på",
    "loginFormEmail": "Email",
    "loginFormPwd": "Kodeord",
    "loginFormBtnLabel": "Log ind",
    "magicLinkFormEmail": "Email",
    "magicLinkFormBtnLabel": "Email",
    "profileFormFirstName": "Fornavn",
    "profileFormMiddleName": "Mellemnavn",
    "profileFormLastName": "Efternavn",
    "profileFormOrganizationName": "Organisationsnavn",
    "profileFormGender": "Køn",
    "profileFormDateOfBirth": "Fødselsdato",
    "profileFormBtnLabel": "Send",
    "logout": "Log ud",
    "accountUserGreeting": "Velkommen",
    "accountHandlerAccountTitle": "Konto",
    "accountHandlerOrdersTitle": "Ordrer",
    "accountHandlerProfileTitle": "Profil",
    "accountHandlerChangePasswordTitle": "Skift kodeord",
    "customerOrderOrderNumber": "Ordrenummer",
    "customerOrderPaymentDate": "Betalingsdato",
    "customerOrderStatus": "Status",
    "customerOrderShippingCost": "Fragtomkostninger",
    "customerOrderDiscount": "Rabat",
    "customerOrderAmount": "Beløb",
    "customerOrderDetailInformation": "Information",
    "customerOrderDetailDeliveryAddress": "Leveringsadresse",
    "customerOrderDetailAddress": "Adresse",
    "customerOrderDetailPostalCode": "Postnummer",
    "customerOrderDetailAttention": "Bemærk",
    "customerOrderDetailMobile": "Mobil",
    "customerOrderDetailYourOrder": "Din ordre",
    "customerOrderDetailPcs": "stk.",
    "noOrdersMessage": "Ingen ordrer fundet",
    "noOrdersBtnLabel": "Fortsæt med at shoppe",
    "emptyCart": "Ingen varer fundet",
    "cartServiceShowDetails": "Vis detaljer",
    "cartServiceHideDetails": "Skjul detaljer",
    "allCategoriesTitle": "Alle kategorier",
    "subcategoriesShowMoreBtnLabel": "Mere",
    "subcategoriesNoCategories": "Ingen kategorier fundet",
    "subcategoriesToolbarTitle": "Kategorier",
    "allCategoriesListDynamic": "Kategori",
    "checkoutNewsLetter": "Abonner gerne på vores nyhedsbrev for at modtage opdateringer om vores produkter og særtilbud: ",
    "newsLetterInputLabel": "Din email",
    "emptyCartBtnLabel": "Start shopping",
    "continueShopping": "Fortsæt med at handle",
    "checkoutCartCartItemsMsg": "produkter i vogn",
    "checkoutPageTitle": "Kasse",
    "checkoutServicesHeading": "Tjenester",
    "addToCart": "Føj til indkøbskurv",
    "noServices": "Ingen tjenester",
    "cartTotal": "Kurv total",
    "cartToCheckout": "Gå til betaling",
    "checkoutSummaryDiscount": "Rabat",
    "checkoutSummarySummaryItemProducts": "Produkter",
    "checkoutSummarySummaryItemServices": "Tjenester",
    "checkoutSummaryCompletePayment": "Færdiggør betaling",
    "checkoutSummaryNoProducts": "Ingen produkter fundet i vogn",
    "checkoutSummaryDiscountMsg": "Vigtigt: Hvis prisen på varen allerede er nedsat, kan det kun have en effekt på varens oprindelige pris.",
    "checkoutSummarySummaryTotal": "Total",
    "checkoutSummarySummaryTotalDiscount": "Total rabat",
    "checkoutSummaryQuantityDiscount": "Mængderabat",
    "quantityDiscountTeaser": "Køb {{nextQty}} og spar {{nextPercentage}} på hele ordren.",
    "quantityDiscountTeaserPack": "Køb {{nextQty}} og spar {{nextPercentage}} på hver pakke.",
    "quantityDiscountProgress": "Tilføj {{unitsToNext}} mere, og spar {{nextPercentage}} på hele ordren.",
    "quantityDiscountProgressPack": "Tilføj {{unitsToNext}} mere, og få {{nextPercentage}} rabat på yderligere {{nextQty}}.",
    "quantityDiscountAchieved": "Du sparer {{currentPercentage}} på denne vare.",
    "quantityDiscountSavingPerUnit": "Du sparer {{nextSaving}}/{{unit}}",
    "quantityDiscountUnitAbbr": "stk.",
    "checkoutSummarySummaryVat": "Moms",
    "checkoutSummarySummaryNetTotal": "Subtotal ekskl. moms",
    "checkoutSummarySummaryContinueToPayment": "Fortsæt til betaling",
    "checkoutSummaryCountryLabel": "Land",
    "checkoutDeliveryStep": "Levering",
    "checkoutPaymentStep": "Gennemfør din ordre",
    "confirmationPageRedirectBtnLabel": "Mine sider",
    "confirmationPageUnknownError": "Ukendt fejl",
    "orderIdNotFound": "Ordre ID ikke fundet",
    "klarnaBackToCart": "Tilbage til vogn",
    "productFilesFileLabel": "dokument",
    "updateCart": "Opdater",
    "productDetailDeliveryLabelUnavailable": "ikke tilgængelig",
    "previousPageBtnLabel": "gå tilbage",
    "productRequest": "Produktopfordring",
    "productListItemBuyToDetails": "Gå til detalje",
    "productNotActive": "Dette produkt er ikke aktivt",
    "articleNumber": "Artikelnummer",
    "gtin": "GTIN",
    "brand": "Mærker",
    "brandsTitle": "Mærker",
    "stockLevel": "Lagerniveau",
    "unit": "enheder",
    "productTabsDescriptionTitle": "Beskrivelse",
    "productTabsSpecificationTitle": "Specifikation",
    "productTabsAttachedFilesTitle": "Vedhæftede filer",
    "productTabsNoDescription": "Ingen beskrivelse",
    "productTabsReviewsTitle": "Anmeldelser",
    "notInStock": "Ikke tilgængelig på lager",
    "noMedias": "Ingen billeder",
    "withMedias": "Se billeder",
    "accessories": "Tilbehør",
    "variants": "Varianter",
    "variantNotFound": "Variant ikke fundet",
    "showMoreBtnLabel": "Mere",
    "priceTitle": "Pris",
    "moreFiltersTitle": "Mere",
    "reset": "Nulstil filtre",
    "cleanFilters": "Rens",
    "search": "Søg",
    "sort": "Sorter",
    "showMoreFilters": "Vis flere filtre",
    "filterTitle": "Filter",
    "filterCategoriesTitle": "Kategori",
    "filterBrandsTitle": "Brand",
    "filterPriceRangeTitle": "Pris",
    "filterClear": "Nulstil filtre",
    "filterSubmitText": "Vis produkter",
    "filterRangeSelectorFrom": "Fra",
    "filterRangeSelectorTo": "Til",
    "productListVerticalTitle": "Sorter og filtrer",
    "productListSearchTitle": "Sort og filtrer",
    "viewTotalProducts": "Se produkter",
    "noProductsFound": "Ingen produkter fundet",
    "removeFilter": "Fjern filter",
    "uniqueOption": "Enestående",
    "notValuesFound": "Ingen værdier fundet",
    "sortAndFilter": "Sorter og filtrer",
    "dropzoneDropMsg": "Slip dine filer her eller klik for at uploade",
    "dropzoneAcceptedFiles": "Accepterede filer",
    "dropzoneReadyMsg": "Klar til upload",
    "dropzoneRejectedMsg": "Afviste filer",
    "prisFilterTitle": "Pris",
    "searchPlaceholder": "Søg produkter",
    "followUs": "Følg os",
    "searchPanelCloseSearch": "Luk søgning",
    "searchPanelOpenSearch": "Åben søgning",
    "searchPopularResults": "Populære resultater:",
    "registerAccount": "Registrer",
    "signupFormEmail": "Email",
    "signupFormFirstName": "Fornavn",
    "signupFormLastName": "Efternavn",
    "signupFormBtnLabel": "Tilmeld",
    "signUpSuccessMsg": "Kontoen er blevet registreret, du vil snart modtage en email med instruktioner.",
    "signUpErrorMsgRecoverPassword": "Har du mistet dit kodeord? Gendan det ",
    "signupRecoverPasswordLink": "her",
    "signupInvalidCredentials": "Ugyldige legitimationsoplysninger",
    "marketplaceProductsIsAvailable": "Tilgængelig",
    "marketplaceProductsIsNotAvailable": "Ikke tilgængelig",
    "marketplaceProductsShowMore": "Vis mere",
    "marketplaceProductsShowLess": "Vis mindre",
    "marketplaceProductsNoVendorsFound": "Ingen forhandlere fundet",
    "showAll": "Vis alle",
    "quantity": "Mængde",
    "seeAll": "Se alle",
    "requestSent": "Anmodning sendt",
    "mobileMenuMultiColumnBack": "Tilbage",
    "mobileMenuMultiColumnSearchPlaceholder": "Søg efter produkt eller tjeneste",
    "checkoutRemoveDiscountCode": "Fjern rabatkode",
    "assistantChat": "Chat",
    "assistantOffers": "Tilbud",
    "vatToggleIncludedLabel": "Inkl. moms",
    "vatToggleExcludedLabel": "Ekskl. moms",
    "vatToggleBusinessPricingLabel": "Erhvervspriser",
    "accountSignInLabel": "Log ind",
    "accountMyAccountFallback": "Min konto",
    "accountMyPages": "Mine ordrer",
    "accountProfile": "Profil",
    "accountLogout": "Log ud",
    "accountNewHere": "Ny her?",
    "accountCreateAccount": "Opret konto",
    "accountViewPricesHeading": "Vis priser",
    "accountBusinessBadge": "Erhvervskonto",
    "ordersListTitle": "Alle ordrer",
    "ordersListRangeOf": "af",
    "ordersListEmpty": "Du har ingen ordrer endnu.",
    "ordersListError": "Vi kunne ikke hente dine ordrer lige nu. Prøv igen senere.",
    "ordersListEmptyCta": "Fortsæt med at shoppe",
    "ordersListItemQuantity": "Antal:",
    "ordersListItemMore": "flere",
    "ordersListOrderIdPrefix": "Ordrenummer:",
    "ordersListDetailsCta": "Vis detaljer →",
    "ordersListPlacedBy": "Bestilt af",
    "ordersListPlacedByUnknown": "Ukendt",
    "orderDetailBack": "← Tilbage til ordrer",
    "orderDetailOrderedOn": "Bestilt",
    "orderDetailOrderedOnBy": "af",
    "orderDetailPlacedByUnknown": "Ukendt",
    "orderDetailShippingAddress": "Leveringsadresse",
    "orderDetailBillingAddress": "Faktureringsadresse",
    "orderDetailProductsHeading": "Produkter",
    "orderDetailShipping": "Fragt",
    "orderDetailDiscount": "Rabat",
    "orderDetailTotal": "Total",
    "orderDetailVatIncluded": "Heraf moms",
    "orderDetailShipmentsHeading": "Forsendelser",
    "orderDetailShipmentTracking": "Sporing",
    "orderDetailShipmentPickup": "Afhentningssted",
    "orderDetailShipmentEstimated": "Forventet levering",
    "orderDetailShipmentShipped": "Afsendt",
    "orderDetailShipmentDelivered": "Leveret",
    "orderDetailShipmentItems": "Indhold",
    "orderDetailProductUnavailable": "Ikke længere tilgængelig",
    "profileFormSectionTitle": "Personlige oplysninger",
    "profileFormFirstNameLabel": "Fornavn",
    "profileFormFirstNameRequired": "Fornavn er påkrævet",
    "profileFormMiddleNameLabel": "Mellemnavn",
    "profileFormLastNameLabel": "Efternavn",
    "profileFormLastNameRequired": "Efternavn er påkrævet",
    "profileFormOrganizationNameLabel": "Organisationsnavn",
    "profileFormDateOfBirthLabel": "Fødselsdato",
    "profileFormGenderLabel": "Køn",
    "profileFormGenderPlaceholder": "Vælg…",
    "profileFormGenderFemale": "Kvinde",
    "profileFormGenderMale": "Mand",
    "profileFormGenderUndefined": "Vil ikke oplyse",
    "profileFormEmailLabel": "E-mail",
    "profileFormPhoneLabel": "Telefon",
    "profileFormPhonePlaceholder": "+45…",
    "profileFormPhoneInvalid": "Indtast et gyldigt telefonnummer.",
    "profileFormSubmit": "Gem",
    "profileFormSubmitLoading": "Gemmer…",
    "profileFormSuccess": "Profilen er opdateret",
    "profileFormGenericError": "Noget gik galt",
    "changePasswordFormSectionTitle": "Skift kodeord",
    "changePasswordFormOldLabel": "Nuværende kodeord",
    "changePasswordFormOldRequired": "Nuværende kodeord er påkrævet",
    "changePasswordFormNewLabel": "Nyt kodeord",
    "changePasswordFormNewDescription": "Mindst 6 tegn, herunder et stort bogstav, et lille bogstav og et tal.",
    "changePasswordFormNewInvalid": "Kodeordet skal være mindst 6 tegn og indeholde et stort bogstav, et lille bogstav og et tal.",
    "changePasswordFormConfirmLabel": "Bekræft nyt kodeord",
    "changePasswordFormConfirmRequired": "Bekræft det nye kodeord",
    "changePasswordFormMismatch": "Kodeordene matcher ikke",
    "changePasswordFormMissingEmail": "Den indloggede konto mangler en e-mail",
    "changePasswordFormSubmit": "Opdater kodeord",
    "changePasswordFormSubmitLoading": "Opdaterer…",
    "changePasswordFormSuccess": "Kodeordet er opdateret",
    "changePasswordFormGenericError": "Noget gik galt",
    "paginationPrev": "Forrige",
    "paginationNext": "Næste",
    "accountSidebarLogout": "Log ud",
    "accountNavOrders": "Ordrer",
    "accountNavProfile": "Profil",
    "accountNavPassword": "Kodeord",
    "accountMetaOrdersTitle": "Mine ordrer",
    "accountMetaOrderDetailTitle": "Ordre",
    "accountMetaProfileTitle": "Profil",
    "accountMetaPasswordTitle": "Kodeord",
    "ordersListItemShowLess": "Vis mindre",
    "orderDetailShipmentPickedUp": "Afhentet",
    "orderDetailPaymentInvoiced": "Faktura",
    "orderDetailPaymentVia": "Betalt via",
    "paymentProviderKlarna": "Klarna",
    "paymentProviderNexi": "Nexi",
    "paymentProviderSvea": "Svea",
    "paymentProviderLedyer": "Ledyer",
    "paymentProviderQliro": "Qliro",
    "paymentProviderBriqpay": "Briqpay",
    "orderStatusDraft": "Kladde",
    "orderStatusCreated": "Oprettet",
    "orderStatusPaid": "Betalt",
    "orderStatusProcessing": "Behandles",
    "orderStatusReady": "Klar",
    "orderStatusPartiallyDelivered": "Delvist leveret",
    "orderStatusDelivered": "Leveret",
    "orderStatusPartiallyReturned": "Delvist returneret",
    "orderStatusReturned": "Returneret",
    "orderStatusCancelled": "Annulleret",
    "orderStatusSettled": "Afregnet",
    "shipmentStatusCreated": "Oprettet",
    "shipmentStatusProcessing": "Behandles",
    "shipmentStatusShipped": "Afsendt",
    "shipmentStatusDelivered": "Leveret",
    "shipmentStatusBlocked": "Blokeret",
    "shipmentStatusCancelled": "Annulleret",
    "shipmentStatusDeleted": "Slettet",
    "invoiceBillingFieldFirstName": "Fornavn",
    "invoiceBillingFieldLastName": "Efternavn",
    "invoiceBillingFieldEmail": "E-mail",
    "invoiceBillingErrorRequired": "Påkrævet felt",
    "invoiceBillingErrorEmail": "Ugyldig e-mailadresse",
    "confirmationSummaryHeading": "Din ordre",
    "confirmationSummaryQuantity": "Antal",
    "confirmationSummaryShipping": "Fragt",
    "confirmationSummaryShippingFree": "Gratis fragt",
    "confirmationSummaryDiscount": "Rabat",
    "confirmationSummaryVat": "Heraf moms",
    "confirmationSummaryTotal": "I alt",
    "confirmationSummaryShippingAddress": "Leveringsadresse",
    "confirmationSummaryPickup": "Afhentningssted",
    "confirmationSummaryTracking": "Spor din forsendelse",
    "confirmationSummaryPaymentMethod": "Betalingsmetode",
    "briqpayConfirmationTitle": "Tak for din ordre!",
    "briqpayConfirmationOrderNumberPrefix": "Ordrenummer: ",
    "briqpayConfirmationPending": "Din betaling behandles og bekræftes snarest.",
    "confirmationSummaryReceiptEmail": "E-mail",
    "invoiceBillingErrorPhone": "Ugyldigt telefonnummer",
    "currency": "DKK",
    "priceCurrency": "DKK"
  },
  "paths": {
    "brandsUrlPath": "/varemarker",
    "categoriesUrlPath": "/kategorier",
    "tagsUrlPath": "/t",
    "productsUrlPath": "/produkter",
    "blogsUrlPath": "/blog"
  },
  "staticLinks": [
    {
      "id": "blog",
      "label": "Blog",
      "path": "/blog"
    }
  ],
  "logoUrl": "https://storage.googleapis.com/gecko-media/EC_1033/store/Vigneron%20-%20Experience%20-%20Black.png",
  "showCart": true,
  "sortingOptions": [
    {
      "sortBy": "price",
      "sortOrder": "DESC",
      "sortLabel": "Pris højt-lavt",
      "default": false
    },
    {
      "sortBy": "price",
      "sortOrder": "ASC",
      "sortLabel": "Pris lavt-højt",
      "default": true
    },
    {
      "sortBy": "created",
      "sortOrder": "DESC",
      "sortLabel": "Nyeste",
      "default": false
    }
  ],
  "desktopItemHeight": "20vw",
  "mobileItemHeight": "75vw",
  "maxContentWidth": 1270,
  "menuMaxContentWidth": 1270,
  "sliderDefaultValues": [
    0,
    200000
  ],
  "freeShippingOver": 0,
  "shippingProviderConfig": {
    "provider": "DEFAULT",
    "simpleShipping": {
      "deliveryFee": 139
    },
    "defaultOptions": {
      "methods": [
        {
          "id": "frakt",
          "kind": "DELIVERY",
          "label": "Frakt",
          "description": null,
          "sortOrder": null,
          "preselected": null,
          "vatBasis": null,
          "pickupIds": null,
          "conditions": null,
          "rates": [
            {
              "id": null,
              "conditions": [
                {
                  "countries": null,
                  "orderAmount": {
                    "from": 0,
                    "to": 3000
                  },
                  "customerType": null,
                  "vatTreatment": null
                }
              ],
              "deliveryFee": 139,
              "minimumOrderAmountForFreeDelivery": null,
              "free": null,
              "vatBasis": null,
              "labels": null
            },
            {
              "id": null,
              "conditions": [
                {
                  "countries": null,
                  "orderAmount": {
                    "from": 3000,
                    "to": null
                  },
                  "customerType": null,
                  "vatTreatment": null
                }
              ],
              "deliveryFee": 399,
              "minimumOrderAmountForFreeDelivery": null,
              "free": null,
              "vatBasis": null,
              "labels": null
            }
          ]
        }
      ],
      "checkoutTopology": null
    }
  },
  "paymentProviderConfig": {
    "providerName": "NEXI",
    "providerOptions": {
      "nexi": {
        "purchaseCurrency": "DKK",
        "countryCode": "DNK",
        "showMerchantName": null,
        "showOrderSummary": null,
        "completePaymentButtonText": null,
        "termsUrl": "/kopvillkor",
        "cancellationTermsUrl": null
      }
    }
  },
  "filtersBeforeShowMore": 3,
  "sliderMaxPrice": 200000,
  "topNavHeight": {
    "panel": {
      "base": 0,
      "sm": "5vh"
    },
    "content": {
      "base": "8vh",
      "sm": "14vh"
    },
    "spacer": {
      "base": "8vh",
      "sm": "19vh"
    },
    "hero": {
      "base": "92vh",
      "sm": "81vh",
      "md": "60vh"
    }
  },
  "topNavSlideOutFeaturedCategories": 3,
  "socialMediaItems": [],
  "topNavPanel": {
    "items": [
      {
        "icon": "FaCrown",
        "label": "Om os",
        "href": "/om-vigneron"
      },
      {
        "icon": "FaRegStar",
        "label": "Kontakt os",
        "href": "/kontakta-oss"
      },
      {
        "icon": "CiGlobe",
        "label": "Vores forhandlere",
        "href": "/aterforsaljare-dk"
      }
    ]
  }
};
export const serverTheme = {}; 
